export default {
  sm: `
  Our data protected by<br>
  our own technology
  `,
};
